import { isAtLeast, SIZE_DESKTOP } from "@escapio/portal/dom/screen";
import { PROVIDER_ESCAPIO } from "@escapio/portal/api/provider-codes";

export const linkTargetForProfile = isAtLeast(SIZE_DESKTOP) ? "_blank" : null;

export const getOfferUrl = (offer, hotelPath) =>
	offer.provider === PROVIDER_ESCAPIO ? hotelPath : offer.book_uri;
